import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

import { Overlay } from './types';

const overlaysSlice = (state: RootState) => state.overlays;

export const selectOverlays = createSelector([overlaysSlice], (state): Overlay => state);

export const selectOverlay = <K extends keyof Overlay>(key: K) =>
  createSelector([overlaysSlice], (state): Overlay[K] => state[key]);
